import React from 'react'

const ContractManagement = () => {
  return (
    <div>ContractManagement</div>
  )
}

export default ContractManagement